import http from '@/services/http';
import apiEndpoints from '@/services/apiEndpoints';

const getDefaultState = () => {
  return {};
};

const state = getDefaultState();
const getters = {};
const mutations = {};
const actions = {
  async checkPromotion (_, payload) {
    return await http.post(apiEndpoints.check_promotion, payload);
  },
  async getByBarcode (_, payload) {
    return await http.get(apiEndpoints.get_promotion_by_barcode.replace('{barcode_number}', payload));
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
